import { render, staticRenderFns } from "./addLockDetail.vue?vue&type=template&id=3125e68c&scoped=true&"
import script from "./addLockDetail.vue?vue&type=script&lang=js&"
export * from "./addLockDetail.vue?vue&type=script&lang=js&"
import style0 from "./addLockDetail.vue?vue&type=style&index=0&id=3125e68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3125e68c",
  null
  
)

export default component.exports